import type { RouteRecordRaw } from 'vue-router';

export const billingRoutes: RouteRecordRaw[] = [
  {
    path: 'billing',
    name: 'Billing',
    component: () => import('@/features/tenant/billing/pages/BillingPage.vue'),
    meta: { menuKey: 'billing' },
  },
];
